import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Axios from 'axios';
import moment from 'moment';
import { authManager, couponsManager, userManager } from '../../helpers/managers';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ReactPixel from 'react-facebook-pixel';
import parseQueryParams from '../../helpers/parseQueryParams';
import { SoundwiseHeader } from '../../components/soundwise_header';
import CreatePublisher from '../../components/create_publisher';
import Loading from '../../components/Loading';
import { handleChargeState } from '../../shared_methods/common_publisher';
import { FullContentWrapper, FullContentSection, LoadingWrapper } from '../../styles/styled';
import { CheckoutWrapper, CheckoutBody, CreditCardForm, PayButton } from '../../styles/checkout';
import InCart from './InCart';
import CustomerCard from './CustomerCard';
import BasicFields from './BasicFields';
import PoweredByStripe from './PoweredByStripe';
import StripePartners from './StripePartners';
import SuccessCharge from './SuccessCharge';
import { createStripeCardSource, parseExpiryMonthAndYear } from '../../helpers/payments';
import { startFreeTrialGTM, payNowGTM } from '../../utils/gtm';
import { ucfirst } from '../../utils/string';
import Checkbox from 'material-ui/Checkbox';
import { getPublisherPlanInfo } from '../../../server/scripts/planTiers';
// linkminkAvailable, promotekitAvailable defined in /client/index.html

class SoundwiseCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: '',
      frequency: '',
      price: 0,
      promoCode: '',
      trialPeriod: null,
      total: '',
      checkoutEmail: '',
      addressLine1: '',
      addressCity: '',
      addressState: '',
      addressZip: '',
      addressCountry: 'US',
      cardType: '',
      cardNumber: '',
      cardCVC: '',
      cardExpMonth: '',
      cardExpYear: '',
      startPaymentSubmission: false,
      enterPublisherName: false,
      publisherName: '',
      defaultSource: {},
      loadingCustomer: false,
      isCustomerLoaded: false,
      emptyCustomer: true,
      chargeState: {},
      startup: true,
      publisherProcessing: false,
      isLoggedIn: false,
      confirmPlanChange: false,
    };

    this.showBillingFields = {
      addressLine1: true,
      addressCity: true,
      addressState: true,
      addressZip: true,
      addressCountry: true,
    };

    // special partner codes
    this.partnerCodes = ['STACKCOMMERCE2020'];

    // init react pixel in production
    if (process.env.NODE_ENV === 'production') {
      ReactPixel.init('2602755553283998');
    }

    this.handleConfirmPlanChange = this.handleConfirmPlanChange.bind(this);
  }

  componentDidMount() {
    if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'staging') {
      console.log('Stripe: setting test key');
      Stripe.setPublishableKey('pk_test_BwjUV9yHQNcgRzx59dSA3Mjt');
    } else {
      Stripe.setPublishableKey('pk_live_rR36Qeypo5CrbG1FKgE1XdlL');
    }

    const { history } = this.props;
    const location = (history && history.location) || {};
    if (has(location, 'search') && location.search.includes('?plan=')) {
      const params = parseQueryParams(location.search);
      let { plan, frequency, promo: promoCode = '' } = params;
      Axios.get(`/api/plan/${plan}/${frequency}`)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            this.setState({
              total: data.amount,
              frequency: data.frequency,
              plan: data.plan,
              price: frequency === 'annual' ? data.monthly : data.amount,
              loader: { ...this.state.loader },
              promoCode,
            });
          }
        })
        .catch(e => {
          console.error('Error plan', e.message);
          history.push('/pricing');
        });
    } else {
      history.push('/pricing');
    }

    authManager.onAuthStateChanged(async user => {
      try {
        // set `isLoggedIn` to state
        // don't wait for the props (theres a delay)
        await new Promise(resolve => {
          this.setState({ isLoggedIn: !isEmpty(user) }, resolve);
        });

        if (!user || isEmpty(user)) {
          throw new Error('User is not logged in');
        }

        const stripeId = await userManager.getProp(user.uid, 'stripe_id', '');
        if (isEmpty(stripeId)) {
          throw new Error('User stripe_id is empty or does not exist');
        }

        this.retrieveCustomer(stripeId);
      } catch (e) {
        console.error(e.message);
        this.setState({
          startup: false,
        });
      }
    });
  }

  retrieveCustomer = stripe_id => {
    this.setState({ loadingCustomer: true }, () => {
      Axios.get('/api/retrieveCustomer', { params: { stripe_id } })
        .then(response => {
          const customer = response.data.customer;
          this.setState({
            startup: false,
            emptyCustomer: false,
            defaultSource: { ...customer.sources.data[0] },
            isCustomerLoaded: true,
            loadingCustomer: false,
          });
        })
        .catch(() => {
          this.setState({
            startup: false,
            loadingCustomer: false,
          });
        });
    });
  };

  handlePaymentField = statekey => {
    return value => {
      if (statekey === 'expiry') {
        const { expMonth, expYear } = parseExpiryMonthAndYear(value);
        return this.setState({
          cardExpMonth: expMonth,
          cardExpYear: expYear,
        });
      }

      this.setState({
        [statekey]: value,
      });
    };
  };

  handlePaymentSuccess = async () => {
    const { isLoggedIn } = this.state;
    const { userInfo, history } = this.props;

    if (isLoggedIn) {
      if (userInfo.publisherID) {
        window.location.replace('/dashboard/soundcasts');
      } else {
        // for listeners converting to be publisher
        this.setState({
          enterPublisherName: true,
        });
      }
    } else {
      // not logged in
      history.push({ pathname: '/signup/admin' }); // skip old '/signup_options'
    }
  };

  onPublisherNameChange = e => {
    const publisherName = e.target.value || '';
    this.setState({
      publisherName,
    });
  };

  onCreatePublisherName = async () => {
    const { chargeState, publisherName } = this.state;
    const { userInfo } = this.props;
    // for listeners converting to be publisher
    this.setState({ publisherProcessing: true }, async () => {
      try {
        await handleChargeState(userInfo, chargeState, publisherName);
        window.location.replace('/dashboard/soundcasts');
      } catch (err) {
        this.setState({ publisherProcessing: false }, () => {
          alert(
            'There was a problem processing your new publisher account, please notify support.'
          );
        });
      }
    });
  };

  handlePromoCode = promoCode => {
    return new Promise(async (resolve, reject) => {
      if (isEmpty(promoCode)) {
        return reject(new Error('Enter a valid promo code.'));
      }

      const coupon = await couponsManager.getByCode(promoCode.trim());
      if (isNull(coupon)) {
        return reject(new Error("This promo code doesn't exist."));
      }

      // const validPromoCodes = ['OFF50', 'NMS'];
      const { plan, total, frequency } = this.state;
      const { userInfo } = this.props;

      if (coupon.affiliate && userInfo && userInfo.publisher && userInfo.publisher.stripe_user_id) {
        // ensure publisher doesn't use his own affiliate code
        if (coupon.affiliate === userInfo.publisher.stripe_user_id) {
          return reject(new Error("Sorry, you can't use your own affiliate code."));
        }
      }

      if (coupon.expiration <= moment().format('X')) {
        return reject(new Error('This promo code has expired.'));
      }

      // if there's a plan restriction, it should honor it
      if ('plan' in coupon && coupon.plan !== plan) {
        return reject(new Error('This promo code does not apply to the plan you chose.'));
      }

      if (coupon.frequency === 'all' || coupon.frequency === frequency) {
        // determine the total price using the percentOff or amountOff
        const discounted = this.getDiscountedPrice(total, coupon);
        const finalTotal = this.getPartnerDiscount(discounted, coupon, promoCode);
        const newState = {
          discounted,
          baseTotal: total,
          total: this.getFormattedPrice(finalTotal),
          promoCode,
          coupon,
        };

        if (coupon.trialPeriod) {
          newState.trialPeriod = coupon.trialPeriod;
        }

        this.setState(newState, () => {
          resolve({ promoCodeInfo: coupon.description });
        });
      } else {
        reject(new Error(`This promo code only applies to ${coupon.frequency} plans!`));
      }
    });
  };

  onSubmit = event => {
    event.preventDefault();
    if (this.state.startPaymentSubmission) {
      return;
    }

    const lastSubmitDate = Number(localStorage.getItem('soundwiseCheckoutPaid') || 0);
    if (Date.now() - lastSubmitDate < 10000) {
      return; // skip, if 10 seconds since last success call not passed
    }

    const { defaultSource, isCustomerLoaded } = this.state;
    this.setState({ startPaymentSubmission: true, paymentError: null }, async () => {
      // use existing source by default
      let source = { ...defaultSource };

      // if no customer info, create new card source
      if (!isCustomerLoaded || isEmpty(defaultSource)) {
        const fields = { ...this.getBillingFields(), ...this.getCardFields() };
        try {
          const nsource = await createStripeCardSource(fields);
          source = { ...nsource };
        } catch (err) {
          return this.setState({
            startPaymentSubmission: false,
            paymentError: err.message,
          });
        }
      }

      this.stripeTokenHandler(source);
    });
  };

  getDiscountedPrice = (total = 0, coupon = {}) => {
    const hasAmountOffOnly = 'amountOff' in coupon && !('percentOff' in coupon);

    // with amountOff
    if (hasAmountOffOnly) {
      return total - coupon.amountOff;
    }

    // with percentOff
    return (total * (100 - coupon.percentOff)) / 100;
  };

  getPartnerDiscount = (total, coupon, promoCode) => {
    if (!this.isPartnerCode(promoCode)) return total;

    // for partner code check credit values
    if ('stripeCredit' in coupon) {
      total -= Number(coupon.stripeCredit);
    }

    if (total < 0) {
      total = 0;
    }

    return total;
  };

  getBasePrice = () => {
    const { frequency, price = 0 } = this.state;
    const calculated = frequency === 'annual' ? price * 12 : price;
    const display = this.getFormattedPrice(calculated);
    const suffix = frequency === 'annual' ? 'year'
      : frequency === 'quarterly' ? 'every 3 months'
      : 'month';
    return `$${display}/${suffix}`;
  };

  getPriceTally = () => {
    const { frequency, discounted = 0, price = 0, coupon = {} } = this.state;
    const calculatedPrice = frequency === 'annual' ? price * 12 : price;
    const discountApplied = this.getFormattedPrice(calculatedPrice - discounted);
    return {
      price: this.getFormattedPrice(calculatedPrice),
      discounted: this.getFormattedPrice(discounted),
      discountApplied: discounted > 0 ? discountApplied : 0,
      coupon,
    };
  };

  getFormattedPrice = price => {
    return Math.round(price) !== price ? Number(price).toFixed(2) : price;
  };

  isPartnerCode = promoCode => this.partnerCodes.includes(promoCode);

  getBillingFields = () => {
    const fields = {};
    ['addressLine1', 'addressCity', 'addressState', 'addressZip', 'addressCountry'].forEach(
      field => {
        fields[field] = '';

        // only get data if field is shown
        if (this.showBillingFields[field]) {
          fields[field] = this.state[field];
        }
      }
    );

    return fields;
  };

  getCardFields = () => {
    const { cardType, cardNumber, cardExpMonth, cardExpYear, cardCVC } = this.state;

    return {
      cardType,
      cardNumber,
      cardExpMonth,
      cardExpYear,
      cardCVC,
    };
  };

  stripeTokenHandler = async response => {
    const { total, plan, frequency, promoCode, trialPeriod, checkoutEmail, confirmPlanChange } = this.state;

    const currency = 'USD';
    const isTrialPeriod = !isNull(trialPeriod) && trialPeriod > 0;
    const { id: userId, email, stripe_id, publisherID, publisher } = this.props.userInfo;

    // include the coupon used if non trial
    const coupon = promoCode && !isTrialPeriod ? promoCode : null;

    // need to record the promoCode used, whether it's for discount or for free trial.
    const metadata = promoCode ? { promoCode } : null;

    try {
      if (response.error) {
        throw new Error(response.error.message);
      }

      // get linkmink data if any (affiliate program)
      const linkminkData = await new Promise(resolve => {
        // data = lmFinished(); // ??? linkmink - lmFinished is not defined
        const data = linkminkAvailable ? lmFinished() : null;
        resolve(isEmpty(data) ? '' : data);
      });

      // get promotekit data if any (affiliate program)
      const promotekitReferral = await new Promise(resolve => {
        const data = promotekitAvailable ? window.promotekit_referral : null;
        resolve(isEmpty(data) ? '' : data);
      });

      const publisherEmail = email ? email[0] : checkoutEmail;
      if (isEmpty(publisherEmail)) {
        throw new Error('Email address is missing.');
      }

      const { status, data = {} } = await Axios.post('/api/buy', {
        userId,
        source: response.id,
        currency,
        receipt_email: publisherEmail,
        customer: stripe_id,
        subscriptionID: (publisher && publisher.subscriptionID) || null,
        coupon,
        metadata,
        trialPeriod,
        publisherID,
        publisherPlan: plan,
        ...(isEmpty(linkminkData) ? {} : { linkminkData }) ,
        ...(isEmpty(promotekitReferral) ? {} : { promotekitReferral }) ,
        plan: `${plan}-${frequency}`,
        statement_descriptor: `Soundwise ${plan} plan: ${frequency}`,
        statement_descriptor_prefix: `Soundwise ${plan} plan: ${frequency}`,
        confirmPlanChange,
      });

      if (status !== 200 || isEmpty(data)) {
        throw new Error('There is an error processing your payment. please try again later.');
      }

      if (isTrialPeriod) {
        startFreeTrialGTM({ type: ucfirst(plan) });
      } else {
        payNowGTM({
          plan: ucfirst(plan),
          frequency: ucfirst(frequency),
          value: total,
          promo: promoCode ? 'Promo' : null,
        });
      }

      const chargeState = {
        plan,
        frequency,
        promoCode,
        trialPeriod,
        chargeData: {
          id: data.id,
          current_period_end: data.current_period_end,
          customer: data.customer,
        },
      }
      const { isLoggedIn } = this.state;
      const { userInfo } = this.props;

      let enterPublisherName = false;
      if (isLoggedIn) {
        if (!isEmpty(userInfo) && !isEmpty(userInfo.publisherID) ) {
          // upgrade an plan of existing publisher
          this.setState({ publisherProcessing: true }, async () => {
            try {
              await handleChargeState(userInfo, chargeState);
              this.setState({ publisherProcessing: false });
            } catch (err) {
              this.setState({ publisherProcessing: false });
              throw new Error(
                'There was a problem updating your publisher account, please notify support.'
              );
            }
          });
        } else {
          // for listeners converting to be publisher
          enterPublisherName = true;
        }
      }

      this.setState(
        {
          startPaymentSubmission: false,
          ...(enterPublisherName ? { enterPublisherName } : {}),
          chargeState: {
            plan,
            frequency,
            promoCode,
            trialPeriod,
            chargeData: {
              id: data.id,
              current_period_end: data.current_period_end,
              customer: data.customer,
            },
          },
        },
        () => {
          // track success plan purchase
          if (process.env.NODE_ENV === 'production') {
            const eventName = isTrialPeriod ? 'StartTrial' : 'Purchase';
            const value = isTrialPeriod ? 0 : total;
            let eventValue = {
              currency,
              value,
            };

            // for purchase event, include plan and frequency
            if (!isTrialPeriod) {
              eventValue = {
                ...eventValue,
                plan,
                frequency,
              };
            }

            ReactPixel.track(eventName, eventValue);
          }

          localStorage.setItem('soundwiseCheckoutPaid', Date.now());
          localStorage.setItem('chargeState', JSON.stringify(this.state.chargeState));
        }
      );
    } catch (e) {
      let paymentError = e.message;
      if ('response' in e) {
        const {
          data: { message },
        } = e.response;
        paymentError = message;
      }

      this.setState({
        paymentError,
        startPaymentSubmission: false,
      });
    }
  };

  renderMainFields = () => {
    const { isLoggedIn, emptyCustomer, defaultSource } = this.state;

    if (!isLoggedIn || emptyCustomer || isEmpty(defaultSource)) {
      return this.renderFormFields();
    }

    return this.renderCustomerFields();
  };

  renderFormFields = () => {
    const {
      addressLine1,
      addressCity,
      addressState,
      addressZip,
      addressCountry,
      cardType,
      cardNumber,
      cardExpMonth,
      cardExpYear,
      cardCVC,
      isLoggedIn,
    } = this.state;

    return (
      <BasicFields
        showEmail={!isLoggedIn}
        showCardFields={true}
        addressLine1={addressLine1}
        addressCity={addressCity}
        addressState={addressState}
        addressZip={addressZip}
        addressCountry={addressCountry}
        cardType={cardType}
        cardNumber={cardNumber}
        cardExpMonth={cardExpMonth}
        cardExpYear={cardExpYear}
        cardCVC={cardCVC}
        onChangeField={this.handlePaymentField}
        showBillingFields={this.showBillingFields}
      />
    );
  };

  renderCustomerFields = () => {
    const { defaultSource, isCustomerLoaded } = this.state;
    const {
      userInfo: { id: userId },
    } = this.props;

    if (!isCustomerLoaded) {
      return <div>Loading details...</div>;
    }

    const {
      address_line1: addressLine1 = '',
      address_city: addressCity = '',
      address_state: addressState = '',
      address_zip: addressZip = '',
      address_country: addressCountry = 'US',
      id: sourceId,
      customer: customerId,
      brand = '',
      last4 = '',
    } = defaultSource;

    return (
      <React.Fragment>
        <CustomerCard
          userId={userId}
          sourceId={sourceId}
          customerId={customerId}
          billing={{
            addressLine1,
            addressCity,
            addressState,
            addressZip,
            addressCountry,
          }}
          card={{
            brand,
            last4,
          }}
          onNewCardCreated={({ source }) => {
            this.setState({ startPaymentSubmission: true, paymentError: null }, () => {
              this.stripeTokenHandler(source);
            });
          }}
          onBillingUpdate={fields => {
            this.setState({
              ...this.state,
              ...fields,
            });
          }}
          showBillingFields={this.showBillingFields}
        />
      </React.Fragment>
    );
  };

  renderPayButton = (forceDisabled = false) => {
    const loading = this.state.startPaymentSubmission;
    const disabled = forceDisabled || loading;
    const btnContent = loading ? (
      <Loading
        text="Processing"
        type="circle"
        align="center"
        size={30}
        fontSize={1.6}
        color="#fff"
        fill="#fff"
      />
    ) : (
      'PAY NOW'
    );

    return (
      <PayButton
        id="buyPayNowBtnTest"
        type="submit"
        className={`contact-submit btn text-white xs-width-100 ${disabled ? 'disabled' : ''}`}>
        {btnContent}
      </PayButton>
    );
  };

  handleConfirmPlanChange(event, checked) {
    this.setState({
      confirmPlanChange: checked,
    });
  };

  renderConfirmPlanChange(planNameWithState) {
    return (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-xs-12">
          <div className="alert alert-danger" role="alert">
            {`You have an active subscription plan: ${planNameWithState}.`}
            <MuiThemeProvider>
              <Checkbox
                label={'Please select to confirm plan change.'}
                labelStyle={{
                  color: '#a94442',
                  width: '100%',
                  fontSize: '1.6rem',
                  fontWeight: 'normal',
                  // lineHeight: '28px',
                  margin: 0,                            
                }}
                iconStyle={{
                  width: 25,
                  height: 25,
                  fill: '#ff8f53',
                  transition: 'none',
                }}
                onCheck={this.handleConfirmPlanChange}
              />
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    );
  };

  renderContent() {
    const {
      total,
      trialPeriod,
      enterPublisherName,
      publisherName,
      chargeState,
      plan,
      frequency,
      promoCode,
      paymentError,
      confirmPlanChange = false,
      isLoggedIn,
    } = this.state;
    const { publisher } = this.props.userInfo || {};
    const {
      isActivePlan,
      isTrialPlan,
      planNameWithState,
    } = getPublisherPlanInfo(publisher);

    const title = `${plan.charAt(0).toUpperCase() + plan.slice(1)} Plan`;
    const interval = frequency === 'annual' ? 'Billed annually'
      : frequency === 'monthly' ? 'Billed monthly'
      : frequency === 'quarterly' ? 'Billed quarterly'
      : 'Billed ???';
    const displayedPrice = this.getBasePrice();
    const priceTally = this.getPriceTally();
    const totalDisplayed = trialPeriod || isTrialPlan ? 0 : total;

    if (enterPublisherName) {
      return (
        <CreatePublisher
          onNameChange={this.onPublisherNameChange}
          name={publisherName}
          onCreate={this.onCreatePublisherName}
        />
      );
    }

    // success payment
    if (!isEmpty(chargeState)) {
      const buttonText = isLoggedIn ? 'Continue' : 'Continue to create an account';
      return (
        <SuccessCharge
          buttonText={buttonText}
          plan={`${plan} ${frequency}`}
          onContinue={this.handlePaymentSuccess}
        />
      );
    }

    return (
      <React.Fragment>
        <InCart
          title={title}
          frequency={interval}
          price={displayedPrice}
          totalPrice={totalDisplayed}
          promoCode={promoCode}
          onAppliedPromo={this.handlePromoCode}
          priceTally={priceTally}
        />
        <CreditCardForm onSubmit={this.onSubmit}>
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              {isActivePlan && this.renderConfirmPlanChange(planNameWithState)}
              {paymentError && (
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-xs-12">
                    <div className="alert alert-danger" role="alert">
                      {paymentError}
                    </div>
                  </div>
                </div>
              )}
              {this.renderMainFields()}
              {this.renderPayButton(isActivePlan && !confirmPlanChange)}
              <PoweredByStripe />
              {/* instead of becoming an affiliate after publisher subscribes, they can now become affiliate first 
              and then use their own promo link to give themselves 30% discount.
              we don't closely monitor affiliate payments,
              so should avoid such situations in our setup as much as possible ( */}
              {/* <StripePartners
                linkmink={linkminkAvailable}
                promotekit={promotekitAvailable}
              /> */}
            </div>
          </div>
        </CreditCardForm>
      </React.Fragment>
    );
  }

  renderBody() {
    const { startup, loadingCustomer, publisherProcessing = false } = this.state;

    if (startup || publisherProcessing) {
      const loadingText = publisherProcessing ? 'Processing Of Publisher'
        : loadingCustomer ? 'Loading Customer' : 'Loading Checkout';
      return (
        <LoadingWrapper height="auto">
          <Loading text={loadingText} align="center" size={50} fontSize={1.6} />
        </LoadingWrapper>
      );
    }

    return (
      <CheckoutWrapper className="padding-three-top xs-padding-ten-top">
        <div className="row">
          <div className="col-lg-4 col-md-8 col-sm-12 center-col">
            <CheckoutBody className="padding-nine sm-padding-ten margin-lr-auto">
              {this.renderContent()}
            </CheckoutBody>
          </div>
        </div>
      </CheckoutWrapper>
    );
  }

  render() {
    return (
      <FullContentWrapper>
        <SoundwiseHeader showIcon={true} />
        <FullContentSection background="#fafafa">
          <MuiThemeProvider>{this.renderBody()}</MuiThemeProvider>
        </FullContentSection>
      </FullContentWrapper>
    );
  }
}

const mapStateToProps = state => {
  const { userInfo } = state.user;
  return { userInfo };
};

export default withRouter(connect(mapStateToProps)(SoundwiseCheckout));
